import React, { useState } from 'react';
import { Col, Row, Container } from "react-bootstrap";
import './EKPlanningTable.css';

const EKPlanningTable = () => {

    // ✅ States
    const [checkBox_1, setCheckBok1] = useState(true);
    const [checkBox_6, setCheckBok6] = useState(true);
    const [checkBox_8, setCheckBok8] = useState(true);


    // Define visibility conditions
    const showUmsatz = checkBox_1 || checkBox_6;
    const showWEGesamt = checkBox_8 || checkBox_6;



    const initialState = {
        planMonth: [
            "Januar",
            "Februar",
            "März",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember",
        ],
        // checkbox 1
        GesamtUmsatz_IsWert_VJ_AS400: Array(12).fill(""),
        UmsatzAnteile: Array(12).fill(""), // done
        PlanWert: Array(12).fill(""), // done
        GesamtUmsatz_IsWertAS400: Array(12).fill(""),
        AbwPercentagePlan: Array(12).fill(""),
        // checkbox2
        LimitplanEKpercentage: Array(12).fill(""), // done
        LimitplanEKPlanWert: Array(12).fill(""), // done
        LimitPlanEkIstWertAS400: Array(12).fill(""),
        LimitPlanEkAbwpercentage: Array(12).fill(""),
        // checkbox3
        KollektionPercentageVOPlanWert: Array(12).fill(""), // done
        KollektionPlanVOWert: Array(12).fill(""), // done
        KollektionPercentagePlanREOWert: Array(12).fill(""), // done
        KollektionPlanREOWert: Array(12).fill(""), // done
        KollektionPlanGesamt: Array(12).fill(""),
        KollektionIstVOWertMobi: Array(12).fill(""),
        EKLimitpro_KollektionIstVOWertAS400: Array(12).fill(""),
        EKLimitpro_KollektionIstREOWertAS400: Array(12).fill(""),
        KollektionIstAS400Gesamt: Array(12).fill(""),
        KollektionAbwPercentagePlan: Array(12).fill(""),
        //
        NOSPercentagePlanVOWert: Array(12).fill(""), // done
        NOSPlanVOWert: Array(12).fill(""), // done
        NOSPercentagePlanREOWert: Array(12).fill(""), // done
        NOSPlanREOWert: Array(12).fill(""), // done
        NOSPlanGesamt: Array(12).fill(""),
        NOSIstVOWertMobi: Array(12).fill(""),
        EKLimitpro_NOSIstVOWertAS400: Array(12).fill(""),
        EKLimitpro_NOSIstREOWertAS400: Array(12).fill(""),
        NOSIstAS400Gesamt: Array(12).fill(""),
        NOSAbwPercentagePlan: Array(12).fill(""),
        //
        NOSPlanGesamt: Array(12).fill(""),
        EKlimitProNOSIstAs400Gesamt: Array(12).fill(""),
        // checkBox4
        AnfangsLagPlanWert: Array(12).fill(""),
        AnfangsLagIstWertAS400: Array(12).fill(""),
        AnfangsLagAbwPercentagePlan: Array(12).fill(""),
        // checknBox5
        AbschriftenAnteilePercentage: Array(12).fill(""),
        AbschriftenGesamtPlanWert: Array(12).fill(""),
        Abschriften_GesamtIstWertAS400: Array(12).fill(""),
        // Abschriften_GesamtIstWertAS400: [
        //   "13,221","20","30","40","50","60","70","80","90","100","110","120"
        // ],
        AbschriftenGesamtAbwPercentagePlan: Array(12).fill(""),
        // AbschriftenGesamtAbwPercentagePlan: [
        //   "1","2","3","4","5","6","7","8","9","10","11","12"
        // ],
        // checkbox 7
        WEVKproKollektionPlanWert: Array(12).fill(""),
        WEVKproKollektionIstWert: Array(12).fill(""),
        WEVKproKollektionAbwPercentagePlan: Array(12).fill(""),
        WEVKproNOSPlanWert: Array(12).fill(""),
        WEVKproNOSIstWert: Array(12).fill(""),
        WEVKproNOSAbwPercentagePlan: Array(12).fill(""),
        // checkbox 8
        WEGesamtPlanWertWEVk: Array(12).fill(""),
        WEGesamtIstWertAS400: Array(12).fill(""),
    };


    const [planningTableData, setPlanningTableData] = useState(initialState);

    // console.log(planningTableData)

    const rowData = planningTableData.planMonth.map((month, index) => ({
        month: month,

        // Checkbox1
        GesamtUmsatz_IsWert_VJ_AS400: planningTableData?.GesamtUmsatz_IsWert_VJ_AS400[index] || "",
        UmsatzAnteile: planningTableData?.UmsatzAnteile[index] || "",
        PlanWert: planningTableData?.PlanWert[index] || "",
        GesamtUmsatz_IsWertAS400: planningTableData?.GesamtUmsatz_IsWertAS400[index] || "",
        AbwPercentagePlan: planningTableData?.AbwPercentagePlan[index] || "",

        // Checkbox2
        LimitplanEKpercentage: planningTableData?.LimitplanEKpercentage[index],
        LimitplanEKPlanWert: planningTableData?.LimitplanEKPlanWert[index],
        LimitPlanEkIstWertAS400: planningTableData?.LimitPlanEkIstWertAS400[index],
        LimitPlanEkAbwpercentage: planningTableData?.LimitPlanEkAbwpercentage[index],

        // Checkbox3
        KollektionPercentageVOPlanWert:
            planningTableData?.KollektionPercentageVOPlanWert[index],
        // KollektionPlanVOWert: planningTableData?.KollektionPlanVOWert[index],
        KollektionPercentagePlanREOWert: planningTableData?.KollektionPercentagePlanREOWert[index],
        // KollektionPlanREOWert: planningTableData?.KollektionPlanREOWert[index],
        KollektionPlanGesamt: planningTableData?.KollektionPlanGesamt[index],
        KollektionIstAS400Gesamt: planningTableData?.KollektionIstAS400Gesamt[index],
        KollektionAbwPercentagePlan: planningTableData?.KollektionAbwPercentagePlan[index],
        // NOS
        NOSPercentagePlanVOWert: planningTableData?.NOSPercentagePlanVOWert[index],
        NOSPlanVOWert: planningTableData?.NOSPlanVOWert[index],
        NOSPercentagePlanREOWert: planningTableData?.NOSPercentagePlanREOWert[index],
        NOSPlanREOWert: planningTableData?.NOSPlanREOWert[index],
        NOSPlanGesamt: planningTableData?.NOSPlanGesamt[index],
        EKLimitpro_NOSIstREOWertAS400: planningTableData?.EKLimitpro_NOSIstREOWertAS400[index],
        EKlimitProNOSIstAs400Gesamt: planningTableData?.EKlimitProNOSIstAs400Gesamt[index],
        NOSAbwPercentagePlan: planningTableData?.NOSAbwPercentagePlan[index],

        // Checkbox4
        AnfangsLagPlanWert: planningTableData?.AnfangsLagPlanWert[index],
        AnfangsLagIstWertAS400: planningTableData?.AnfangsLagIstWertAS400[index],
        AnfangsLagAbwPercentagePlan: planningTableData?.AnfangsLagAbwPercentagePlan[index],

        // Checkbox5
        AbschriftenAnteilePercentage: planningTableData?.AbschriftenAnteilePercentage[index],
        AbschriftenGesamtPlanWert: planningTableData?.AbschriftenGesamtPlanWert[index],
        Abschriften_GesamtIstWertAS400: planningTableData?.Abschriften_GesamtIstWertAS400[index] || "",

        // checkBox8
        WEVKproKollektionPlanWert: planningTableData?.WEVKproKollektionPlanWert[index],
        WEVKproKollektionIstWert: planningTableData?.WEVKproKollektionIstWert[index],
        WEVKproKollektionAbwPercentagePlan: planningTableData?.WEVKproKollektionAbwPercentagePlan[index],
        WEVKproNOSPlanWert: planningTableData?.WEVKproNOSPlanWert[index],
        WEVKproNOSIstWert: planningTableData?.WEVKproNOSIstWert[index],
        WEVKproNOSAbwPercentagePlan: planningTableData?.WEVKproNOSAbwPercentagePlan[index],
    }));

    const getCheckvalue = (e) => {
        const { name, checked } = e.target;
        // console.log(name, checked);
        if (name === "checkbox1") {
            setCheckBok1(e.target.checked);
        } else if (name === "checkbox6") {
            setCheckBok6(e.target.checked);
        } else if (name === "checkbox8") {
            setCheckBok8(e.target.checked);
        }
    };

    return (
        <div className="border rounded bg-white w-100">
            <div className="ekPlanning-allCheckBox_main">
                <Row className="">
                    {/* <div className='vkPlanning-allCheckBox_main_col'> */}
                    <Col className="ekPlanning-allCheckBox">
                        <div className="ekPlanning-checkbox_input">
                            <input
                                type="checkbox"
                                name="checkbox1"
                                checked={checkBox_1}
                                onChange={getCheckvalue}
                            />
                        </div>
                        <div className="ekPlanning-checkbox_text">Limitplan EK Gesamt</div>
                    </Col>
                    <Col className="ekPlanning-allCheckBox">
                        <div className="ekPlanning-checkbox_input">
                            <input
                                type="checkbox"
                                name="checkbox8"
                                checked={checkBox_8}
                                onChange={getCheckvalue}
                            />
                        </div>
                        <div className="ekPlanning-checkbox_text"> EK Limit pro Wareneingang</div>
                    </Col>
                    <Col className="ekPlanning-allCheckBox">
                        <div className="ekPlanning-checkbox_input">
                            <input
                                type="checkbox"
                                name="checkbox6"
                                checked={checkBox_6}
                                onChange={getCheckvalue}
                            />
                        </div>
                        <div className="ekPlanning-checkbox_text">Ist</div>
                    </Col>
                </Row>
            </div>
            <div className="ekPlanningTableContainerMain">
                <table className="planning_table_data">
                    <thead>
                        <tr className="table_th">
                            <th className="table_subheader" rowSpan={2}>
                                Monat
                            </th>
                            {/*  */}
                            {showUmsatz && (
                                <th
                                    className="table_subheader"
                                    colSpan={
                                        checkBox_1 && checkBox_6
                                            ? 6
                                            : checkBox_6
                                                ? 3
                                                : checkBox_1
                                                    ? 3
                                                    : 0
                                    }
                                >
                                    Limitplan EK Gesamt
                                </th>
                            )}
                            {/*  */}
                            {showWEGesamt && (
                                <th
                                    className="table_subheader"
                                    colSpan={
                                        checkBox_8 && checkBox_6
                                            ? 15
                                            : checkBox_6
                                                ? 6
                                                : checkBox_8
                                                    ? 9
                                                    : 0
                                    }
                                >
                                    EK Limit pro Wareneingang
                                </th>
                            )}
                            {/*  */}
                        </tr>
                        <tr className="table_subheader">
                            {showUmsatz && (
                                <>
                                    {checkBox_1 && (
                                        <>
                                            <th>%</th>
                                            <th>Plan Wert</th>
                                        </>
                                    )}

                                    {checkBox_6 && (
                                        <th>
                                            <div>Ist-Wert</div>
                                            <div>AS400</div>
                                        </th>
                                    )}

                                    {checkBox_1 && (
                                        <>
                                            <th>
                                                Abw. %<br />
                                                Plan
                                            </th>
                                        </>
                                    )}
                                    {checkBox_6 && (
                                        <>
                                            <th>
                                                Ist-Wert VJ<br />
                                                AS400
                                            </th>
                                            <th>
                                                Ist-Wert Mobi
                                            </th>
                                        </>
                                    )}
                                </>
                            )}

                            {/*  */}
                            {showWEGesamt ? (
                                <>
                                    {checkBox_8 && (
                                        <>
                                            <th>
                                                Kollektion %<br /> Plan  Wert
                                            </th>
                                            <th>
                                                Kollektion
                                                <br /> Plan Wert
                                            </th>
                                        </>
                                    )}
                                    {checkBox_6 && (<>
                                        <th>
                                            Kollektion Ist <br />Wert Mobi
                                        </th>
                                        <th>
                                            Kollektion Ist <br />Wert AS400
                                        </th>
                                    </>)}

                                    {checkBox_8 && (
                                        <>
                                            <th>
                                                Kollektion  <br />Abw %<br /> Plan
                                            </th>
                                        </>
                                    )}



                                    {checkBox_8 ? (
                                        <>
                                            <th>
                                                NOS %  Plan<br /> VO Wert
                                            </th>
                                            <th>
                                                NOS Plan VO <br />Wert
                                            </th>
                                            <th>
                                                NOS % Plan <br />
                                                REO Wert
                                            </th>
                                            <th>
                                                NOS Plan
                                                <br /> REO Wert
                                            </th>
                                        </>
                                    ) : null}

                                    {checkBox_8 && (
                                        <>
                                            <th>
                                                NOS Plan <br />
                                                Gesamt
                                            </th>
                                        </>
                                    )}
                                    {checkBox_6 && (
                                        <>
                                            <th>
                                                NOS Ist VO <br />
                                                Wert Mobi
                                            </th>
                                            <th>
                                                NOS Ist VO
                                                <br /> Wert AS400
                                            </th>
                                            <th>
                                                NOS ISt REO
                                                <br /> Wert AS400
                                            </th>
                                            <th>
                                                NOS Ist<br />AS400
                                                <br /> Gesamt
                                            </th>
                                        </>
                                    )}
                                    {checkBox_8 && (<>
                                        <th>
                                            NOS Abw %
                                            <br /> Plan
                                        </th>
                                    </>)
                                    }


                                </>
                            ) : null}
                            {/*  */}
                        </tr>
                    </thead>
                    <tbody className="planning_table_body">
                        {rowData?.map((data, index) => (
                            <tr className="planning_table_body_tr">
                                <td className="table_body_td_month" style={{ textAlign: 'left' }}>{data.month}</td>
                                {/*  */}
                                {showUmsatz && (
                                    <>
                                        {/* --- Only Ist-Wert VJ AS400 --- */}
                                        {checkBox_6 && (
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    name="GesamtUmsatz_IsWert_VJ_AS400"
                                                    // value={
                                                    //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                    //     index
                                                    //     ] || ""
                                                    // }
                                                    // onChange={(e) => getHandleChange(e, index)}
                                                    style={{
                                                        background: "rgb(236 245 166)",
                                                        border: "1px solid rgb(236 245 166)",
                                                        textAlign: 'right'
                                                    }}
                                                />
                                            </td>
                                        )}

                                        {/* --- UmsatzAnteile & PlanWert only if checkBox_1 true --- */}
                                        {checkBox_1 && (
                                            <>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="UmsatzAnteile"
                                                        // value={planningTableData.UmsatzAnteile[index] || ""}
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: index % 2 === 0 ? "#d4ecfb" : "white",
                                                            textAlign: 'right',
                                                            border:
                                                                index % 2 === 0
                                                                    ? "1px solid #d4ecfb"
                                                                    : "1px solid white",
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="PlanWert"
                                                        // value={planningTableData.PlanWert[index] || ""}
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: index % 2 === 0 ? "#d4ecfb" : "white",
                                                            border:
                                                                index % 2 === 0
                                                                    ? "1px solid #d4ecfb"
                                                                    : "1px solid white",
                                                            textAlign: 'right',
                                                        }}
                                                    />
                                                </td>
                                            </>
                                        )}

                                        {/* --- Ist-Wert AS400 (visible when checkBox_6 OR checkBox_1 true) --- */}
                                        {checkBox_6 && (
                                            <>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWertAS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWertAS400[index] ||
                                                        //     ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right',
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWertAS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWertAS400[index] ||
                                                        //     ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right',
                                                        }}
                                                    />
                                                </td>
                                            </>

                                        )}

                                        {/* --- Abw. % Plan only if checkBox_1 true --- */}
                                        {checkBox_1 && (
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    name="AbwPercentagePlan"
                                                    // value={
                                                    //     formatNumber2(planningTableData.AbwPercentagePlan[index] || "")
                                                    // }
                                                    // onChange={(e) => getHandleChange(e, index)}
                                                    style={{
                                                        background: "rgb(236 245 166)",
                                                        border: "1px solid rgb(236 245 166)",
                                                        textAlign: 'right',
                                                    }}
                                                />
                                            </td>
                                        )}
                                    </>
                                )}
                                {/* --- Same concept for WE-Gesamt --- */}
                                {showWEGesamt && (
                                    <>
                                        {checkBox_8 && (<>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    name="GesamtUmsatz_IsWert_VJ_AS400"
                                                    // value={
                                                    //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                    //     index
                                                    //     ] || ""
                                                    // }
                                                    // onChange={(e) => getHandleChange(e, index)}
                                                    style={{
                                                        background: "rgb(236 245 166)",
                                                        border: "1px solid rgb(236 245 166)",
                                                        textAlign: 'right'
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    name="GesamtUmsatz_IsWert_VJ_AS400"
                                                    // value={
                                                    //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                    //     index
                                                    //     ] || ""
                                                    // }
                                                    // onChange={(e) => getHandleChange(e, index)}
                                                    style={{
                                                        background: "rgb(236 245 166)",
                                                        border: "1px solid rgb(236 245 166)",
                                                        textAlign: 'right'
                                                    }}
                                                />
                                            </td>
                                        </>
                                        )}
                                        {checkBox_6 && (
                                            <>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                            </>
                                        )}
                                        {checkBox_8 && (
                                            <>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                            </>
                                        )}
                                        {checkBox_8 && (<>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    name="GesamtUmsatz_IsWert_VJ_AS400"
                                                    // value={
                                                    //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                    //     index
                                                    //     ] || ""
                                                    // }
                                                    // onChange={(e) => getHandleChange(e, index)}
                                                    style={{
                                                        background: "rgb(236 245 166)",
                                                        border: "1px solid rgb(236 245 166)",
                                                        textAlign: 'right'
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    name="GesamtUmsatz_IsWert_VJ_AS400"
                                                    // value={
                                                    //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                    //     index
                                                    //     ] || ""
                                                    // }
                                                    // onChange={(e) => getHandleChange(e, index)}
                                                    style={{
                                                        background: "rgb(236 245 166)",
                                                        border: "1px solid rgb(236 245 166)",
                                                        textAlign: 'right'
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    name="GesamtUmsatz_IsWert_VJ_AS400"
                                                    // value={
                                                    //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                    //     index
                                                    //     ] || ""
                                                    // }
                                                    // onChange={(e) => getHandleChange(e, index)}
                                                    style={{
                                                        background: "rgb(236 245 166)",
                                                        border: "1px solid rgb(236 245 166)",
                                                        textAlign: 'right'
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    name="GesamtUmsatz_IsWert_VJ_AS400"
                                                    // value={
                                                    //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                    //     index
                                                    //     ] || ""
                                                    // }
                                                    // onChange={(e) => getHandleChange(e, index)}
                                                    style={{
                                                        background: "rgb(236 245 166)",
                                                        border: "1px solid rgb(236 245 166)",
                                                        textAlign: 'right'
                                                    }}
                                                />
                                            </td>
                                        </>)}
                                        {checkBox_8 && (
                                            <>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                            </>)}
                                        {checkBox_6 && (
                                            <>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                            </>
                                        )}
                                        {checkBox_8 && (
                                            <>
                                                <td>
                                                    <input
                                                        autoComplete="off"
                                                        name="GesamtUmsatz_IsWert_VJ_AS400"
                                                        // value={
                                                        //     planningTableData.GesamtUmsatz_IsWert_VJ_AS400[
                                                        //     index
                                                        //     ] || ""
                                                        // }
                                                        // onChange={(e) => getHandleChange(e, index)}
                                                        style={{
                                                            background: "rgb(236 245 166)",
                                                            border: "1px solid rgb(236 245 166)",
                                                            textAlign: 'right'
                                                        }}
                                                    />
                                                </td>
                                            </>
                                        )}
                                    </>
                                )}
                            </tr>
                        ))}
                        {/*  */}

                        {/* Totals row */}

                        <tr className="planning_table_body_tr_total">
                            <td className="planning_table_total_child" style={{ textAlign: 'left', padding: 0 }}>Gesamt</td>
                            {showUmsatz && (
                                <>
                                    {checkBox_6 ? (
                                        <td className="planning_table_total_child">
                                            {/* {formatGerman(totals.GesamtUmsatz_IsWert_VJ_AS400)} */}
                                        </td>
                                    ) : null}

                                    {checkBox_1 && (
                                        <>
                                            <td className="planning_table_total_child">
                                                {/* {totals.UmsatzAnteile || ''} */}
                                            </td>
                                            <td className="planning_table_total_child">
                                                {/* {formatGerman(totals.PlanWert)} */}
                                            </td>
                                        </>
                                    )}

                                    {checkBox_6 ? (
                                        <td className="planning_table_total_child">
                                            {/* {formatGerman(totals.GesamtUmsatz_IsWertAS400)} */}
                                        </td>
                                    ) : null}

                                    {checkBox_1 && (
                                        <>
                                            <td className="planning_table_total_child">
                                                {/* {formatGerman(totals.AbwPercentagePlan)} */}
                                            </td>
                                        </>
                                    )}
                                </>
                            )}
                            {/*  */}
                            {showWEGesamt && (
                                <>
                                    {checkBox_8 && (
                                        <>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                        </>
                                    )}

                                    {checkBox_6 && (
                                        <>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                        </>
                                    )}
                                    {checkBox_8 && (
                                        <>
                                            <td className="planning_table_total_child"></td>
                                        </>
                                    )}
                                    {checkBox_8 && (
                                        <>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                        </>
                                    )}
                                    {checkBox_8 && (
                                        <>
                                            <td className="planning_table_total_child"></td>
                                        </>
                                    )}
                                    {checkBox_6 && (
                                        <>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                            <td className="planning_table_total_child"></td>
                                        </>
                                    )}
                                    {checkBox_8 && (
                                        <>
                                            <td className="planning_table_total_child"></td>
                                        </>
                                    )}
                                </>
                            )}
                            {/*  */}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default EKPlanningTable